<template>
  <div class="page-container">
    <h1 class="page-title">{{ t("pages.products.tape.title") }}</h1>

    <!-- 引言部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.tape.introduction.content'))"
      ></div>
      <div class="content-section">
      <div style="text-align: center;">
        <img src="/images/products/带材图.jpg" />
     
      </div>
    </div>
    </div>

    <div class="decorative-divider"></div>

    <!-- 应用案例部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[0].title") }}
        </h2>
      </div>
      <div class="model-container">
        <TapeLayerThreeD v-if="is3D" />
      </div>
    </div>
    <div class="decorative-divider"></div>
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[1].title") }}
        </h2>
      </div>
    </div>
    <div class="content-section">
      <div style="text-align: center;">
        <img :src="productSpecImage" />
     
      </div>
    </div>
    <div class="decorative-divider"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/pinia/stores/lang";
import TapeLayerThreeD from "@/components/Products/TapeLayerThreeD.vue";
// import TapeLayerCanvas from '@/components/Products/TapeLayerCanvas.vue';

const { t } = useI18n();
const langStore = useLangStore();
const is3D = ref(true);

// 判断当前是否为英文
const isEnglish = computed(() => !langStore.currentLang.startsWith('zh'));

// 动态获取产品规格图片路径
const productSpecImage = computed(() => 
  isEnglish.value ? '/images/products/产品规格英文.png' : '/images/products/产品规格.png'
);

const handleModeChange = (value: boolean) => {
  console.log(`切换到${value ? "3D" : "2D"}模式`);
};
// 渲染带有换行的内容
const renderContent = (content: string) => {
  if (!content) return "";
  return content
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph}</p>`)
    .join("");
};
</script>

<style scoped>
@import "@/assets/styles/content-blocks.scss";

.model-controls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.model-container {
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 40px;
}

.detail-section {
  margin-top: 40px;
}

.detail-section h2 {
  color: var(--primary-color);
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 1.8rem;
}

.detail-section p {
  line-height: 1.6;
  margin-bottom: 20px;
}

.detail-section ul {
  margin-bottom: 30px;
}

.detail-section li {
  margin-bottom: 10px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 30px 15px;
  }
}
.page-container {
  overflow: auto;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 0.9em;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.spec-table th, .spec-table td {
  border: 1px solid #ccc;
  padding: 8px 5px;
  vertical-align: middle; /* 垂直居中 */
  min-width: 60px; /* 最小宽度 */
  line-height: 1.4; /* 增加行高改善可读性 */
}

.spec-table thead th {
  background-color: #f2f2f2;
  font-weight: bold;
  padding: 10px 5px;
}

.spec-table tbody tr:nth-child(even) {
  /* background-color: #f9f9f9; */ /* 可选：斑马条纹 */
}
.spec-table tbody tr:last-child td {
  background-color: #f2f2f2;
  font-weight: bold;
}
.spec-table td:first-child, /* 应用领域, 可选配参数, 基本性能 的单元格 */
.spec-table td:nth-child(2):not([rowspan]) /* 不包含跨行的第二列 */ {
  /* background-color: #e8f4fd; /* 淡蓝色背景 */
}

.spec-table .category-header {
  background-color: #e9e9e9; /* 灰色背景 */
  font-weight: bold;
  writing-mode: vertical-lr; /* 垂直书写 */
  text-orientation: mixed;
  width: 30px; /* 固定宽度 */
}
.spec-table .rotate-header span {
    display: inline-block; /* 使旋转生效 */
    /* transform: rotate(180deg); /* 如果需要文字倒置 */
}


.spec-table .sub-category {
  font-weight: bold;
  /* background-color: #f8f8f8; */
  text-align: left;
  padding-left: 10px;
}

.spec-table .inline-image {
  height: 40px; /* 图片高度 */
  vertical-align: middle; /* 图片垂直居中 */
  margin-right: 5px; /* 图片右边距 */
}
.spec-table .rebco-logo {
  height: 12px; /* REBCO logo 高度 */
  vertical-align: middle;
  margin-left: 5px;
}
</style> 